import { computed, get } from '@ember/object';

export default function containsByProperty(arrayKey, itemKey) {
  return computed(`${arrayKey}.[]`, itemKey, function () {
    return get(this, arrayKey).includes(get(this, itemKey));
  });
}
